// Tvoje originalne slike
export const IMG_TERRACE_CHAIRS = 'https://static.readdy.ai/image/610b801a81a299b5cf2b47908013d228/d678962607610f8669b30d178f1f11c0.png'; // terasa s stolčki in Coca-Cola dežniki ob jezeru
export const IMG_COFFEE = 'https://static.readdy.ai/image/610b801a81a299b5cf2b47908013d228/0fabbfea551cc28b77cb438baeae1d5a.png'; // kava latte art
export const IMG_BARSTAFF = 'https://static.readdy.ai/image/610b801a81a299b5cf2b47908013d228/f773574e98ea16db32a46d667990e0fc.png'; // naš šank, bar s logotipom, rogljički, drsnik, Martini logo
export const IMG_TERRACE_COCA = 'https://static.readdy.ai/image/610b801a81a299b5cf2b47908013d228/77b0210b7608d58ebde8ddad43c70efd.png'; // slika 3 – terasa Coca-Cola dežniki
export const IMG_BOATS = 'https://static.readdy.ai/image/610b801a81a299b5cf2b47908013d228/9ea3e02bf5986cb38dbb35cc173c4698.png'; // cel objekt z odrazom v vodi, brez čolnov
export const IMG_DECKCHAIRS = 'https://static.readdy.ai/image/610b801a81a299b5cf2b47908013d228/de1b24d1252577465e2a66fe35059b4a.png'; // slika 5 – leseni stolčki Martini
export const IMG_TERRACE_WIDE = 'https://static.readdy.ai/image/610b801a81a299b5cf2b47908013d228/61140cb07c98780bc2b675d0dd167fc2.png'; // terasa z dežniki, ležalniki in jezerom
export const IMG_TERRACE_LAKE = 'https://static.readdy.ai/image/610b801a81a299b5cf2b47908013d228/fc13916804f0e27a2415be3ed4ecab7c.png'; // terasa ob jezeru z odrazom neba
// Originalne AI slike
export const IMG_TERRACE_DAY = 'https://static.readdy.ai/image/610b801a81a299b5cf2b47908013d228/d9c6e886e7263c4f9647f9d24ab685e1.png';
export const IMG_NIGHT_TERRACE = 'https://static.readdy.ai/image/610b801a81a299b5cf2b47908013d228/77b0210b7608d58ebde8ddad43c70efd.png';
export const IMG_BEER = 'https://static.readdy.ai/image/610b801a81a299b5cf2b47908013d228/f88d77620066c97b37fb36c5d2d5ebe7.png'; // originalno pivo AI
export const IMG_COCKTAIL = 'https://static.readdy.ai/image/610b801a81a299b5cf2b47908013d228/bc18092be579f08106653062bfca4c77.png'; // 3 koktejli na pladnu ob jezeru
export const IMG_LOGO = 'https://public.readdy.ai/ai/img_res/cb044b86-8b4c-4375-9f13-9096d04de556.png';
export const IMG_COCKTAIL_MOJITO = 'https://readdy.ai/api/search-image?query=Fresh%20mojito%20cocktail%20in%20a%20tall%20glass%20with%20mint%20leaves%2C%20lime%20wedges%2C%20ice%20cubes%2C%20sparkling%20water%20bubbles%2C%20white%20rum%2C%20on%20a%20warm%20wooden%20bar%20counter%20with%20soft%20bokeh%20background%2C%20tropical%20summer%20vibe%2C%20bright%20natural%20daylight%2C%20clean%20minimal%20composition%2C%20editorial%20food%20photography%20style%20with%20shallow%20depth%20of%20field&width=600&height=800&seq=cocktail-mojito-01&orientation=portrait';
export const IMG_COCKTAIL_SPRITZ = 'https://readdy.ai/api/search-image?query=Aperol%20spritz%20cocktail%20in%20a%20large%20wine%20glass%20with%20orange%20slice%20garnish%2C%20ice%20cubes%2C%20vibrant%20orange%20color%2C%20sparkling%20prosecco%20bubbles%2C%20on%20a%20terrace%20table%20overlooking%20a%20lake%20with%20golden%20sunset%20light%2C%20summer%20evening%20atmosphere%2C%20elegant%20aperitivo%20moment%2C%20clean%20composition%20with%20warm%20tones&width=600&height=800&seq=cocktail-spritz-02&orientation=portrait';
export const IMG_COCKTAIL_NEGRONI = 'https://readdy.ai/api/search-image?query=Classic%20negroni%20cocktail%20in%20a%20heavy%20rocks%20glass%20with%20large%20ice%20cube%2C%20orange%20peel%20twist%2C%20deep%20ruby%20red%20color%2C%20gin%20and%20campari%2C%20on%20a%20dark%20marble%20bar%20surface%2C%20moody%20ambient%20lighting%20with%20candlelight%2C%20sophisticated%20evening%20bar%20vibe%2C%20editorial%20cocktail%20photography%2C%20dramatic%20shadows&width=600&height=800&seq=cocktail-negroni-03&orientation=portrait';
export const IMG_COCKTAIL_LINEUP = 'https://readdy.ai/api/search-image?query=Three%20beautiful%20colorful%20cocktails%20in%20different%20glasses%20lined%20up%20on%20a%20polished%20wooden%20bar%20counter%2C%20mojito%20with%20mint%2C%20negroni%20deep%20red%2C%20margarita%20with%20salt%20rim%2C%20soft%20warm%20backlight%20from%20behind%20the%20bar%2C%20bokeh%20lights%20in%20background%2C%20golden%20hour%20ambiance%2C%20elegant%20bar%20atmosphere%2C%20clean%20editorial%20style%2C%20shallow%20depth%20of%20field&width=1200&height=800&seq=gallery-cocktails-lineup&orientation=landscape';
export const IMG_COCKTAIL_POUR = 'https://readdy.ai/api/search-image?query=Bartender%20pouring%20a%20vibrant%20orange%20cocktail%20from%20a%20shaker%20into%20a%20crystal%20martini%20glass%2C%20droplets%20mid%20air%2C%20dramatic%20side%20lighting%2C%20dark%20moody%20bar%20background%20with%20shelf%20of%20bottles%2C%20action%20shot%2C%20professional%20cocktail%20photography%2C%20high%20contrast%2C%20luxurious%20night%20bar%20vibe&width=1200&height=800&seq=gallery-cocktail-pour&orientation=landscape';
export const IMG_COCKTAIL_PAIR = 'https://readdy.ai/api/search-image?query=Two%20elegant%20cocktails%20on%20a%20terrace%20table%20overlooking%20water%20at%20sunset%2C%20aperol%20spritz%20and%20espresso%20martini%2C%20golden%20sunset%20light%20reflecting%20on%20the%20drinks%2C%20lake%20or%20sea%20in%20background%2C%20warm%20summer%20evening%20atmosphere%2C%20travel%20lifestyle%20photography%2C%20clean%20minimal%20table%20setting%2C%20dreamy%20bokeh&width=1200&height=800&seq=gallery-cocktail-pair&orientation=landscape';

export const NAV_LINKS = [
  { label: 'DOMOV', href: '#domov' },
  { label: 'O NAS', href: '#o-nas' },
  { label: 'PONUDBA', href: '#ponudba' },
  { label: 'GALERIJA', href: '#galerija' },
  { label: 'DOŽIVETJE', href: '#dozivetje' },
  { label: 'KONTAKT', href: '#kontakt' },
];

export const GOOGLE_MAPS_URL = 'https://www.google.com/maps/dir/?api=1&destination=46.41068,15.88766';
export const GOOGLE_MAPS_EMBED = 'https://maps.google.com/maps?q=Bar+Ranca%2C+K+Jezeru+18a%2C+2250+Ptuj&t=&z=16&ie=UTF8&iwloc=&output=embed';

export const DRINK_CATEGORIES = [
  {
    name: 'KAVA & TOPLI NAPITKI',
    icon: 'fa-solid fa-mug-hot',
    drinks: [
      { name: 'Espresso', price: '1,90 €' },
      { name: 'Americano', price: '1,90 €' },
      { name: 'Macchiato', price: '2,10 €' },
      { name: 'Kava z mlekom', price: '2,30 €' },
      { name: 'Kava s smetano', price: '2,40 €' },
      { name: 'Cappuccino', price: '2,40 €' },
      { name: 'Mala bela kava', price: '2,40 €' },
      { name: 'Bela kava', price: '2,70 €' },
      { name: 'Latte Macchiato', price: '3,00 €' },
      { name: 'Latte Macchiato z okusom', price: '3,40 €' },
      { name: 'Latte Freddo', price: '2,80 €' },
      { name: 'Ice Latte Macchiato', price: '3,90 €' },
      { name: 'Ice Latte Macchiato z okusom', price: '4,30 €' },
      { name: 'Ledena kava', price: '5,90 €' },
      { name: 'Ledena kava z okusom', price: '6,40 €' },
      { name: 'Cold Brew kava', price: '3,90 €' },
      { name: 'Čaj', price: '2,50 €' },
      { name: 'Kakav', price: '2,50 €' },
      { name: 'Kakav s smetano', price: '3,20 €' },
      { name: 'Čokočino', price: '1,40 €' },
      { name: 'Čokočino z rastlinskim mlekom', price: '1,60 €' },
    ],
    notes: [
      { name: 'Brezkofeinska kava', price: '+0,60 €' },
      { name: 'Rastlinsko mleko', price: '+0,40 / 0,80 €' },
    ],
  },
  {
    name: 'BREZALKOHOLNE PIJAČE',
    icon: 'fa-solid fa-glass-water',
    drinks: [
      { name: 'Coca-Cola 0,1 L', price: '1,50 €' },
      { name: 'Coca-Cola 0,25 L', price: '3,40 €' },
      { name: 'Fanta Orange 0,25 L', price: '3,40 €' },
      { name: 'Sprite 0,25 L', price: '3,40 €' },
      { name: 'Schweppes 0,25 L', price: '3,50 €' },
      { name: 'Cockta 0,25 L', price: '3,40 €' },
      { name: 'Cedevita', price: '3,00 €' },
      { name: 'Fructal 0,2 L', price: '3,30 €' },
      { name: 'Jabolčni sok 0,1 L', price: '1,80 €' },
      { name: 'Ananasov/Breskov/Pomarančni sok 0,1 L', price: '1,90 €' },
      { name: 'Naravni pomarančni sok 0,1 L', price: '2,40 €' },
      { name: 'Naravna limonada 0,45 L', price: '3,50 €' },
      { name: 'Limonada Monin 0,45 L', price: '3,90 €' },
      { name: 'Soda z okusom Monin 0,45 L', price: '3,90 €' },
      { name: 'Domači ledeni čaj Monin 0,45 L', price: '3,90 €' },
      { name: 'Bubble Tea 0,5 L', price: '4,50 €' },
      { name: 'Monster 0,25 L', price: '3,80 €' },
      { name: 'Red Bull 0,25 L', price: '3,90 €' },
    ],
  },
  {
    name: 'VODA',
    icon: 'fa-solid fa-droplet',
    drinks: [
      { name: 'Römerquelle negazirana 0,33 L', price: '2,90 €' },
      { name: 'Römerquelle gazirana 0,33 L', price: '3,00 €' },
      { name: 'Römerquelle Emotion 0,33 L', price: '3,00 €' },
      { name: 'Römerquelle negazirana 0,5 L', price: '2,50 €' },
      { name: 'Smartwater negazirana 0,6 L', price: '2,80 €' },
      { name: 'Powerade 0,5 L', price: '3,90 €' },
      { name: 'Voda z okusom 0,5 L', price: '3,00 €' },
      { name: 'Radenska 0,1 L', price: '0,90 €' },
      { name: 'Voda z okusom Monin 0,5 L', price: '3,50 €' },
      { name: 'Kombucha GR Brewery 0,33 L', price: '3,90 €' },
    ],
  },
  {
    name: 'PREMIUM MIKSERJI',
    icon: 'fa-solid fa-flask',
    drinks: [
      { name: 'Three Cents 0,2 L', price: '3,60 €' },
    ],
  },
  {
    name: 'PIVO',
    icon: 'fa-solid fa-beer-mug-empty',
    drinks: [
      { name: 'Union 0,33 L', price: '3,20 €' },
      { name: 'Zlatorog 0,33 L', price: '3,20 €' },
      { name: 'Heineken 0,33 L', price: '3,80 €' },
      { name: 'Salitos', price: '4,00 €' },
      { name: 'Smile 0,33 L', price: '3,60 €' },
      { name: 'Točeno Heineken 0,25 L', price: '3,50 €' },
      { name: 'Točeno Heineken 0,5 L', price: '4,30 €' },
      { name: 'Frizi Beer 0,33 L', price: '3,80 €' },
      { name: 'Frizi Pale Ale 0,3 L', price: '3,50 €' },
      { name: 'Frizi Pale Ale 0,5 L', price: '4,40 €' },
      { name: 'Točeno Union IPA 0,3 L', price: '3,80 €' },
      { name: 'Točeno Union IPA 0,5 L', price: '4,60 €' },
      { name: 'Malt', price: '3,20 €' },
      { name: 'Heineken brezalkoholno', price: '3,60 €' },
      { name: 'Radler Grenivka 0,5 L', price: '3,60 €' },
      { name: 'Radler Isotonic 0,5 L', price: '3,60 €' },
      { name: 'Točeno Frizi Lager 0,3 L', price: '3,50 €' },
      { name: 'Točeno Frizi Lager 0,5 L', price: '4,30 €' },
      { name: 'Domači hišni radler 0,5 L', price: '4,00 €' },
    ],
  },
  {
    name: 'VINO',
    icon: 'fa-solid fa-wine-glass',
    drinks: [
      { name: 'Haložan Pullus', price: '1,80 €/dcl' },
      { name: 'Rumeni muškat Pullus', price: '3,50 €/dcl' },
      { name: 'Sauvignon Pullus', price: '3,50 €/dcl' },
      { name: 'Refošk Simčič', price: '2,50 €/dcl' },
      { name: 'Sladki refošk Simčič', price: '3,50 €/dcl' },
      { name: 'Modra frankinja Pullus', price: '3,30 €/dcl' },
      { name: 'Cabernet Sauvignon Vina Koper', price: '3,50 €/dcl' },
      { name: 'Cviček Krško', price: '2,00 €/dcl' },
    ],
  },
  {
    name: 'PENINA',
    icon: 'fa-solid fa-champagne-glasses',
    drinks: [
      { name: 'Martini Prosecco', price: '4,00 €/dcl' },
      { name: 'Martini Asti', price: '4,00 €/dcl' },
      { name: 'Martini Prosecco Rosé', price: '4,00 €/dcl' },
    ],
  },
  {
    name: 'MARTINI VERMOUTHS',
    icon: 'fa-solid fa-martini-glass-citrus',
    drinks: [
      { name: 'Martini Bianco 0,1 L', price: '4,00 €' },
      { name: 'Martini Rosso 0,1 L', price: '4,00 €' },
      { name: 'Martini Floreale 0,1 L', price: '4,00 €' },
      { name: 'Martini Vibrante 0,1 L', price: '4,00 €' },
    ],
  },
  {
    name: 'ŽGANE PIJAČE',
    icon: 'fa-solid fa-whiskey-glass',
    drinks: [
      { name: 'Finlandia vodka', price: '3,50 €' },
      { name: 'Bacardi Carta Blanca', price: '3,50 €' },
      { name: 'Bacardi Carta Oro', price: '3,50 €' },
      { name: 'Bacardi Razz', price: '3,50 €' },
      { name: 'Bombay Sapphire gin', price: '3,80 €' },
      { name: 'Bombay Sunset gin', price: '3,80 €' },
      { name: 'Whitley & Neill gin', price: '3,80 €' },
      { name: 'Monkey 47 gin', price: '5,90 €' },
      { name: 'Jack Daniel\'s Old No. 7', price: '3,80 €' },
      { name: 'Gentleman Jack', price: '5,00 €' },
      { name: 'Jameson', price: '3,80 €' },
      { name: 'Jameson Black Barrel', price: '4,50 €' },
      { name: 'Carolans', price: '3,20 €' },
      { name: 'Martell VSOP', price: '4,00 €' },
      { name: 'Malibu', price: '3,00 €' },
      { name: 'Martini Riserva Speciale Bitter', price: '3,00 €' },
      { name: 'Pelinkovec Ultimus Poetovio', price: '3,50 €' },
      { name: 'Jägermeister', price: '3,50 €' },
      { name: 'Travarica Vidarica', price: '3,00 €' },
      { name: 'Zlatna Viljamovka', price: '3,50 €' },
      { name: 'Zlatna Dunja', price: '3,50 €' },
      { name: 'Zlatna Kajsija', price: '3,50 €' },
      { name: 'Zlatna Šljiva', price: '3,50 €' },
      { name: 'Baba višnja', price: '3,00 €' },
      { name: 'Borovničevec Kejžar', price: '3,00 €' },
    ],
  },
  {
    name: 'COCKTAILS',
    icon: 'fa-solid fa-martini-glass',
    drinks: [
      { name: 'Martini Negroni', price: '7,50 €' },
      { name: 'Finlandia Garden', price: '6,80 €' },
      { name: '(Spiced) Cuba Libre', price: '7,20 €' },
      { name: 'Mojito', price: '8,50 €' },
      { name: 'Flavoured Mojito', price: '9,00 €' },
      { name: 'Bacardi Razz Mojito', price: '8,50 €' },
      { name: 'Sex on the Beach', price: '7,90 €' },
      { name: 'Piña Colada', price: '7,90 €' },
      { name: 'Paloma', price: '8,00 €' },
      { name: 'Palomita', price: '8,00 €' },
      { name: 'Caribbean Mule', price: '8,20 €' },
      { name: 'Moscow Mule', price: '8,00 €' },
      { name: 'Pineapple Spice', price: '7,90 €' },
      { name: 'Strawberry Margarita', price: '8,50 €' },
      { name: 'Basil & Figs', price: '7,90 €' },
      { name: 'Pornstar Martini', price: '8,80 €' },
      { name: 'Finlandia Espresso Martini', price: '7,50 €' },
      { name: 'Bacardi Razz Lemonade', price: '7,90 €' },
      { name: 'Cherry Fizz', price: '7,90 €' },
      { name: 'Fizzy Colada', price: '7,90 €' },
    ],
  },
  {
    name: 'BREZALKOHOLNI COCKTAILI',
    icon: 'fa-solid fa-cup-togo',
    drinks: [
      { name: 'Martini Floreale/Vibrante & Tonic', price: '6,00 €' },
      { name: 'Floreale Fizz', price: '6,00 €' },
      { name: 'Bitter & Fresh', price: '6,00 €' },
      { name: 'Gin Tonic (brezalkoholni)', price: '5,50 €' },
      { name: 'Cuddles on the Beach', price: '5,50 €' },
      { name: 'Virgin Colada', price: '5,50 €' },
      { name: 'Virgin Mojito', price: '5,90 €' },
      { name: 'Cherry Fizz', price: '7,20 €' },
      { name: 'Cherry Bubbles', price: '5,50 €' },
    ],
  },
  {
    name: 'SPRITZ',
    icon: 'fa-solid fa-wine-bottle',
    drinks: [
      { name: 'Martini Fiero & Tonic', price: '6,60 €' },
      { name: 'Martini Fiero Spritz', price: '7,00 €' },
      { name: 'Martini Bianco Spritz', price: '7,00 €' },
      { name: 'Passoa Spritz', price: '7,40 €' },
      { name: 'Aperativo Spritz', price: '7,20 €' },
      { name: 'Limoncello Spritz', price: '7,20 €' },
      { name: 'Strawberry Limoncello Spritz', price: '7,20 €' },
      { name: 'Teranelo', price: '7,50 €' },
      { name: 'Peach & Rose Cup', price: '7,00 €' },
      { name: 'Monin Flavour Spritz', price: '7,00 €' },
      { name: 'Ramazzotti Rosato Spritz', price: '6,60 €' },
      { name: 'Mimosa', price: '6,00 €' },
      { name: 'Bellini', price: '6,00 €' },
    ],
  },
];

export const GALLERY_IMAGES = [
  { src: IMG_BOATS, alt: 'Panoramski pogled na Bar Ranca Ptuj in Ptujsko jezero z odrazom', title: 'Ranca ob jezeru' },
  { src: IMG_TERRACE_CHAIRS, alt: 'Mirna terasa bara Ranca z rumenim dežnikom ob jezeru', title: 'Jutro ob jezeru' },
  { src: IMG_DECKCHAIRS, alt: 'Leseni ležalniki Martini ob pomolu bara Ranca', title: 'Sončni ležalniki' },
  { src: IMG_TERRACE_COCA, alt: 'Terasa bara Ranca Ptuj z Coca-Cola dežniki', title: 'Zunanja terasa' },
  { src: IMG_BARSTAFF, alt: 'Šank bara Ranca Ptuj z logotipom', title: 'Naš šank' },
];